import { ThemeProvider } from '@emotion/react';
import { AuthProvider, ProtectedRoute } from '@webmotors/consumer-shared-auth';
import { Header, Footer } from '@webmotors/consumer-shared-ui';

import { theme } from '@styles/theme';
import { ChatRenderer } from '@/page/chat-renderer';
import { useApp } from './app.hook';

function App() {
  const { showHeader, showFooter, authToken, portalBaseUrl, footerConfig } =
    useApp();

  return (
    <ThemeProvider theme={theme}>
      <AuthProvider>
        <ProtectedRoute fallback={null}>
          {showHeader && (
            <Header authToken={authToken} baseUrl={portalBaseUrl} />
          )}
          <ChatRenderer />
          {showFooter && <Footer {...footerConfig} />}
        </ProtectedRoute>
      </AuthProvider>
    </ThemeProvider>
  );
}

App.displayName = 'App';
export { App };
